import { debounce } from "lodash-es";
import { Search } from "lucide-react";
import { Dispatch, SetStateAction } from "react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type SearchBarProps = {
  search: string | null;
  setSearch: Dispatch<SetStateAction<string | null>>;
  className?: string;
  placeholder?: string;
};

export function SearchBar({
  search,
  setSearch,
  className,
  placeholder = "Search",
}: SearchBarProps) {
  const debouncedSearch = debounce((value: string) => {
    setSearch(value);
  }, 300);

  return (
    <div className="relative w-full">
      <Input
        type="search"
        placeholder={placeholder}
        defaultValue={search ?? ""}
        onChange={(e) => {
          debouncedSearch(e.target.value);
        }}
        className={cn("pl-8 sm:w-80", className)}
      />
      <Search className="absolute left-2 top-1/2 size-4 -translate-y-1/2 text-muted" />
    </div>
  );
}
